<template>
	<v-container grid-list-md>
		<ValidationObserver ref="obs" v-slot="{ invalid }">
			<v-form>
				<v-card>
					<v-card-title primary-title>
						<v-btn icon><v-icon>mdi-arrow-left</v-icon></v-btn>
						{{ $t("title.create_customer") }}
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<form-customer v-model="item"></form-customer>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn
							color="primary"
							@click.native="submit()"
							:loading="item.processing"
						>
							<v-icon left>mdi-content-save</v-icon>
							{{ $t("Save") }}
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-form>
		</ValidationObserver>
	</v-container>
</template>

<script>
export default {
	props: ["roles"],
	data() {
		return {
			item: this.$inertia.form({
				image: {},
				first_name: null,
				last_name: null,
				female: null,
				male: null,
				birthday: null,
				phone: null,
				email: null,
				company_name: null,
				address: null,
				city: null,
				telegram: null,
				language: null,
				title: null,
				active: null,
			}),
		};
	},

	methods: {
		submit() {
			this.item.post(this.$route("central.customers.store"));
		},
	},
};
</script>